export default __webpack_public_path__ + "static/media/whiteSelected.eb0a9d95.svg";